import React from 'react';
import { XCircle, CheckCircle } from 'lucide-react';
import { FadeIn } from './FadeIn';

export const ProblemSolution: React.FC = () => {
  return (
    <section className="py-24 px-6 relative min-h-[80vh] flex items-center">
      <div className="max-w-6xl mx-auto w-full">
        <FadeIn>
            <h2 className="text-3xl md:text-4xl font-bold tracking-tight text-white mb-16 text-center">
                The Digital Landscape Shift
            </h2>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* Problem Card */}
          <FadeIn delay={0.1} className="h-full">
            <div className="group relative h-full p-8 md:p-12 rounded-3xl border border-white/5 bg-neutral-900/50 hover:bg-neutral-900 transition-colors min-h-[400px]">
              <div className="absolute top-8 right-8 text-neutral-700 group-hover:text-red-500/50 transition-colors duration-500">
                <XCircle size={40} strokeWidth={1.5} />
              </div>
              <h3 className="text-2xl font-semibold text-neutral-400 mb-4">The Old Way</h3>
              <p className="text-4xl font-bold text-neutral-500 mb-6 tracking-tight">
                Slow, confusing sites that lose customers.
              </p>
              <ul className="space-y-4 text-neutral-500">
                  <li className="flex items-center gap-3">
                      <span className="w-1.5 h-1.5 bg-red-900 rounded-full"></span>
                      Generic Templates
                  </li>
                  <li className="flex items-center gap-3">
                      <span className="w-1.5 h-1.5 bg-red-900 rounded-full"></span>
                      Zero SEO Strategy
                  </li>
                  <li className="flex items-center gap-3">
                      <span className="w-1.5 h-1.5 bg-red-900 rounded-full"></span>
                      Mobile Incompatible
                  </li>
              </ul>
            </div>
          </FadeIn>

          {/* Solution Card */}
          <FadeIn delay={0.2} className="h-full">
            <div className="group relative h-full rounded-3xl p-[1px] bg-gradient-to-br from-blue-500/50 to-purple-500/50 overflow-hidden min-h-[400px]">
                <div className="absolute inset-0 bg-blue-500/10 blur-xl group-hover:bg-blue-500/20 transition-all duration-700"></div>
                <div className="relative h-full bg-neutral-950 rounded-[23px] p-8 md:p-12">
                    <div className="absolute top-8 right-8 text-blue-500 shadow-[0_0_15px_rgba(59,130,246,0.5)] rounded-full">
                        <CheckCircle size={40} strokeWidth={1.5} />
                    </div>
                    <h3 className="text-2xl font-semibold text-white mb-4">The New Way</h3>
                    <p className="text-4xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-blue-200 to-white mb-6 tracking-tight">
                        Fast, AI-driven platforms that capture leads globally.
                    </p>
                    <ul className="space-y-4 text-neutral-300">
                        <li className="flex items-center gap-3">
                            <span className="w-1.5 h-1.5 bg-blue-500 rounded-full shadow-[0_0_5px_rgba(59,130,246,1)]"></span>
                            Custom High-Performance React
                        </li>
                        <li className="flex items-center gap-3">
                            <span className="w-1.5 h-1.5 bg-blue-500 rounded-full shadow-[0_0_5px_rgba(59,130,246,1)]"></span>
                            International SEO Domination
                        </li>
                        <li className="flex items-center gap-3">
                            <span className="w-1.5 h-1.5 bg-blue-500 rounded-full shadow-[0_0_5px_rgba(59,130,246,1)]"></span>
                            AI Lead Qualification
                        </li>
                    </ul>
                </div>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>
  );
};